<mat-form-field appearance="outline" class="full-width notes-cell">
  <textarea
    #textarea
    matInput
    maxlength="2500"
    cdkTextareaAutosize
    class="notes-cell__textarea"
    [attr.aria-label]="labelKey() | translate | capitalize"
    [disabled]="disabled()"
    [value]="value() ?? ''"
    (input)="valueInput.emit(textarea.value)"
    (focusout)="save.emit()"></textarea>
  @if (saveState() === 'saving') {
    <mat-hint align="start" class="hint">
      <mat-spinner class="custom-spinner"></mat-spinner>
      <span>{{ 'general.actions.saving' | translate }}</span>
    </mat-hint>
  } @else if (saveState() === 'saved') {
    <mat-hint align="start" class="hint saved-hint">
      <mat-icon inline>done</mat-icon>
      <span>{{ 'general.words.saved' | translate }}</span>
    </mat-hint>
  } @else {
    <mat-hint align="start" class="hint"></mat-hint>
  }
  @if (showCounter()) {
    <mat-hint align="end">{{ textarea.value.length }} / 2500</mat-hint>
  }
</mat-form-field>
